(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('geodata', {
            parent: 'entity',
            url: '/geodata?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.geodata.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geodata/geodata.html',
                    controller: 'GeodataController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geodata');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('geodata-detail', {
            parent: 'entity',
            url: '/geodata/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.geodata.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/geodata/geodata-detail.html',
                    controller: 'GeodataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('geodata');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Geodata', function($stateParams, Geodata) {
                    return Geodata.get({id : $stateParams.id});
                }]
            }
        })
        .state('geodata.new', {
            parent: 'geodata',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-dialog.html',
                    controller: 'GeodataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                country: null,
                                region: null,
                                prefecture: null,
                                city: null,
                                street: null,
                                postalCode: null,
                                fromNum1: null,
                                toNum1: null,
                                fromNum2: null,
                                toNum2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('geodata');
                });
            }]
        })
        .state('geodata.edit', {
            parent: 'geodata',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-dialog.html',
                    controller: 'GeodataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Geodata', function(Geodata) {
                            return Geodata.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('geodata.delete', {
            parent: 'geodata',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/geodata/geodata-delete-dialog.html',
                    controller: 'GeodataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Geodata', function(Geodata) {
                            return Geodata.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('geodata', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
